export const QUESTIONNAIRE_LOAD_REQUEST = "questionnaire/load_request";
export const QUESTIONNAIRE_LOAD_SUCCESS = "questionnaire/load_success";
export const QUESTIONNAIRE_LOAD_FAILURE = "questionnaire/load_failure";

export const SET_QUESTIONS_LOADING = "questionnaire/set_questions_loading";